// extracted by mini-css-extract-plugin
module.exports = {"featureGridWrap":"why-were-different-section_featureGridWrap__fR_a2"};